import { Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import Avatar, {
  AvatarSize,
  AvatarStatus,
} from '../../../components/Avatar/Avatar';
import Button from '../../../components/Button/Button';
import ModalHeader from '../../../components/ModalHeader';
import { getAllProfiles } from '../../../services/profiles';
import { capitalizeFirstLetter } from '../../../utils/utils';

export type customBeneficiariesSummaryModalProps = {
  showSummaryModal: boolean;
  handleCloseSummaryModal: () => void;
};

const BeneficiariesSummaryModal = ({
  showSummaryModal,
  handleCloseSummaryModal,
}: customBeneficiariesSummaryModalProps) => {
  const primaryProfile = getAllProfiles().data.filter(
    (profile) => profile.relationship === 'spouse'
  )[0];

  const secondaryProfiles = getAllProfiles().data.filter(
    (profile) => profile.id === '3' || profile.id === '4'
  );

  const secondaryProfilesFraction = `${(100 / secondaryProfiles.length).toFixed(2).replace(/\.00/,'')}%`;

  return (
    <Modal
      show={showSummaryModal}
      onHide={handleCloseSummaryModal}
      dialogClassName="modal-sm"
    >
      <ModalHeader closeButton>
        <h4 className="text-sm-20-lg-32">Summary</h4>
      </ModalHeader>
      <ModalBody>
        <section className="fw-light text-sub1">
          <span>HSA Investment</span>
        </section>
        <section className="mt-10 mt-lg-12 border rounded">
          <div className="p-10">
            <div>
              <h6 className="fw-light">Primary</h6>
            </div>
            <div className="d-flex flex-row justify-content-between mt-4 mt-lg-10">
              <div className="col-1 me-7 d-flex align-items-center">
                <Avatar
                  id={primaryProfile.id}
                  status={AvatarStatus.ENABLED}
                  size={AvatarSize.SMALL}
                  name={`${primaryProfile.firstName} ${primaryProfile.lastName}`}
                />
              </div>
              <div className="d-flex flex-column col-9">
                <span className="text-sub1 fw-light lh-xxs">{`${primaryProfile.firstName} ${primaryProfile.lastName}`}</span>
                <span className="text-sub1 fw-light text-ligther-grey lh-xxs">
                  {capitalizeFirstLetter(primaryProfile.relationship)}
                </span>
              </div>
              <div className="col-1 align-items-end">
                <span className="text-sub1 text-primary fw-normal lh-xxs">
                  100%
                </span>
              </div>
            </div>
          </div>
          <div className="border-top p-10">
            <div>
              <h6 className="fw-light">Contingent</h6>
            </div>
            {secondaryProfiles.map((secondaryProfiles, index) => {
              return (
                <div key={index} className="d-flex flex-row justify-content-between mt-4 mt-lg-4">
                  <div className="col-1 me-7 d-flex align-items-center">
                    <Avatar
                      id={secondaryProfiles.id}
                      status={AvatarStatus.ENABLED}
                      size={AvatarSize.SMALL}
                      name={`${secondaryProfiles.firstName} ${secondaryProfiles.lastName}`}
                    />
                  </div>
                  <div className="d-flex flex-column col-9">
                    <span className="text-sub1 fw-light lh-xxs">{`${secondaryProfiles.firstName} ${secondaryProfiles.lastName}`}</span>
                    <span className="text-sub1 fw-light text-ligther-grey lh-xxs">
                      {capitalizeFirstLetter(secondaryProfiles.relationship)}
                    </span>
                  </div>
                  <div className="col-1 align-items-end">
                    <span className="text-sub1 text-primary fw-normal lh-xxs">
                      {secondaryProfilesFraction}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary-outline"
          className={'order-1 order-lg-3 mt-7 mt-lg-0'}
          onClick={handleCloseSummaryModal}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BeneficiariesSummaryModal;
